import { createSlice } from "@reduxjs/toolkit";

const cmsManagementSlice = createSlice({
    name: 'cmsManagement',
    initialState: {
        data: [],
        isLoading: false
    },
    reducers: {
        startLoading: (state) => { state.isLoading = true },
        stopLoading: (state) => { state.isLoading = false },
        getUpdateCms: (state, action) => { state.data = action.payload },
    }
});

const cmsManagementActions = cmsManagementSlice.actions;

export { cmsManagementActions };
export default cmsManagementSlice.reducer;